/** Placeholder for an admin section: real layout + table foundation, empty until its phase lands. */
import {
  AppContainer,
  Badge,
  Button,
  DataTable,
  PageHeader,
  SearchInput,
  StateView,
} from '@hopex/ui';
import type { AdminNavItem } from '../shell/nav.ts';

type Row = { id: string };

export function SectionPage({ item }: { item: AdminNavItem }) {
  return (
    <AppContainer>
      <PageHeader title={item.label} actions={<Badge tone="accent">به‌زودی</Badge>} />
      <div className="mb-4 flex flex-wrap items-center gap-3">
        <SearchInput
          label={`جستجو در ${item.label}`}
          placeholder="جستجو…"
          className="w-full max-w-sm"
        />
        <Button variant="secondary" size="sm" isDisabled>
          خروجی
        </Button>
      </div>
      <DataTable<Row>
        label={item.label}
        rows={[]}
        columns={[
          { id: 'ref', header: 'شناسه', isRowHeader: true, cell: () => null },
          { id: 'subject', header: 'موضوع', cell: () => null },
          { id: 'age', header: 'زمان در صف', numeric: true, cell: () => null },
          { id: 'status', header: 'وضعیت', cell: () => null },
        ]}
        empty={
          <StateView
            compact
            kind="unavailable"
            title="این بخش هنوز فعال نشده است"
            description="هیچ اقدام عملیاتی از این صفحه انجام نمی‌شود."
          />
        }
      />
    </AppContainer>
  );
}

export function NotFoundPage() {
  return (
    <AppContainer size="reading">
      <StateView kind="empty" title="صفحه پیدا نشد" />
    </AppContainer>
  );
}
